import { Link, Outlet } from '@remix-run/react'
import { useState } from 'react'
import { z } from 'zod'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { vendors } from '#app/utils/vendors.ts'
import { type VendorsType } from '#types/vendors.js'

export const MAX_UPLOAD_SIZE = 1024 * 1024 * 3 // 3MB
export const BaseReciboFormSchema = {
	fecha_de_compra: z.date().optional(),
	uso_de_cfdi: z.string().optional(),
	forma_de_pago: z.string().optional(),
	monto_total: z
		.union([z.string().transform(x => x.replace(/[^0-9.-]+/g, '')), z.number()])
		.pipe(z.coerce.number().min(0.0001).max(999999999))
		.optional(),
	observaciones: z.string().optional(),
}
export default function RecibosRoute() {
	const [selectedVendor, setSelectedVendor] = useState<string>('')
	return (
		<div className="container mb-48 mt-12 flex flex-col items-center justify-center gap-6">
			<h1 className="text-h1">Sube un Recibo nuevo</h1>
			<div className="flex w-full justify-end">
				<Link to="/recibos">
					<Button>Regresar a Recibos</Button>
				</Link>
			</div>
			<div className="flex w-full flex-col">
				<h2 className="mb-6 text-h2">Selecciona un proveedor</h2>
				<div className="flex w-full">
					{Object.keys(vendors).map(key => {
						const isActiveVendor = selectedVendor === key

						const { label, active } = vendors[key as VendorsType]
						const disabledClassname = !active
							? 'pointer-events-none disabled:opacity-50'
							: ''
						const className = `mr-6 ${disabledClassname}`
						const buttonClassName = isActiveVendor
							? 'bg-blue-500 text-white' // Set the button color to blue if active
							: 'bg-gray-200 text-black' // Default button color

						return (
							<Link
								to={`/recibos/nuevo/${key}`}
								key={key}
								className={className}
							>
								<Button
									disabled={!active}
									className={buttonClassName}
									onClick={() => setSelectedVendor(key)}
								>
									{label}
								</Button>
							</Link>
						)
					})}
				</div>
				<Outlet />
			</div>
		</div>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
